import { render, staticRenderFns } from "./review-volunteer-application.vue?vue&type=template&id=51500edf&scoped=true"
import script from "./review-volunteer-application.vue?vue&type=script&lang=js"
export * from "./review-volunteer-application.vue?vue&type=script&lang=js"
import style0 from "./review-volunteer-application.vue?vue&type=style&index=0&id=51500edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51500edf",
  null
  
)

export default component.exports